import Vue from 'vue'
import App from './App.vue'
import './styles/app.scss';
import { BootstrapVue } from 'bootstrap-vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    phone: 700,
    tablet: 1000,
    laptop: 1250,
    xlg: Infinity,
  }
})

Vue.use(BootstrapVue)
Vue.config.productionTip = false

Vue.mixin({
  methods: {
    newWindow(url) {
      window.open(url, "_blank");		
    }  
  }
})

new Vue({
  render: h => h(App),
}).$mount('#app')
